/* EXTERNAL PACKAGES */
import axios from "axios";

const request = axios.create({
  baseURL: 'https://alumni-connection-hub-backend-v2-895924407291.us-central1.run.app/',
  timeout: 100000, // Adjust the timeout as needed
});

request.interceptors.request.use(
  (config) => {
 

    return config;
  },
  (error) => Promise.reject(error)
);

export default request;
